import type { ShowcasedItem } from "~/components/ShowcaseInlineCard/types";

export const reasons: ShowcasedItem[] = [
  {
    title: "Tangible Stability",
    description:
      "There are few assets that compare with Real estate in terms of stability and intrinsic value, with property values typically appreciating over time.",
    icon: "/images/svgs/check.svg",
  },
  {
    title: "Long-Term Growth",
    description:
      "Historically, real estate investments have shown long-term appreciation potential, offering opportunities for significant capital gains.",
    icon: "/images/svgs/check.svg",
  },
  {
    title: "Consistent Income",
    description:
      "When properties are managed efficiently, your ROI is assured. Rental properties provide a reliable source of income through steady rental payments.",
    icon: "/images/svgs/check.svg",
  },
  {
    title: "Risk Reduction",
    description:
      "If you're already an investor, adding real estate to your portfolio mitigates risk by spreading your investments across different asset types, increasing stability.",
    icon: "/images/svgs/check.svg",
  },
];
